export interface DeliveryLogScriptKey {
    storeID?: number | null;
    rxNumber?: number | null;
    rfNumber?: number | null;
}

/**
 * Keys a prescription by its fill identity. Built from the raw fields rather than the `rxID` getter,
 * which only resolves on Prescription instances — these arrays hold plain deserialized objects as
 * often as not. Matches the key format used by orderContentSignature.
 */
export function deliveryLogScriptKeys(scripts?: Array<DeliveryLogScriptKey> | null): Array<string> {
    return (scripts ?? []).map(rx => `${rx.storeID}-${rx.rxNumber}-${rx.rfNumber || 0}`);
}

/**
 * True when the order's prescription list has changed since it was last persisted. The delivery log
 * is rendered server-side from committed state and never sees the in-memory list, so printing while
 * this is true produces a document that silently disagrees with the screen.
 *
 * Order-insensitive: the grid re-emits its selection in row order, which is not the order the list
 * was loaded in, and a reordered-but-identical list is not a real change.
 */
export function isDeliveryLogStale(
    current?: Array<DeliveryLogScriptKey> | null,
    savedKeys?: Array<string> | null,
): boolean {
    const currentKeys = deliveryLogScriptKeys(current);
    const saved = [...(savedKeys ?? [])].sort();
    if (currentKeys.length !== saved.length) return true;
    return currentKeys.sort().some((key, i) => key !== saved[i]);
}
